:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileFrameScrollWrapper_1ex3u_7 {
  position: absolute;
  width: 100%;
  height: 100%; }
  ._mobileFrameScrollWrapper_1ex3u_7._withShadowExtraSpace_1ex3u_11 {
    height: calc(100% + 30px);
    top: -15px; }
    ._mobileFrameScrollWrapper_1ex3u_7._withShadowExtraSpace_1ex3u_11 ._mobileFrame_1ex3u_7 {
      height: calc(100% - 30px);
      top: 15px; }
  ._mobileFrameScrollWrapper_1ex3u_7._withFrameExtraSpace_1ex3u_17 {
    height: calc(100% + 80px);
    top: -40px; }
    ._mobileFrameScrollWrapper_1ex3u_7._withFrameExtraSpace_1ex3u_17 ._mobileFrame_1ex3u_7 {
      height: calc(100% - 80px);
      top: 40px; }
  ._mobileFrameScrollWrapper_1ex3u_7 ._mobileFrameScrollContainer_1ex3u_23 {
    position: absolute;
    overflow-y: scroll;
    width: 100%;
    height: 100%; }
    ._mobileFrameScrollWrapper_1ex3u_7 ._mobileFrameScrollContainer_1ex3u_23._mobileFrameScrollContainerFixedMarginTop_1ex3u_28 {
      overflow-y: hidden;
      width: calc(100% - var(--stage-scrollbar-width)); }
    ._mobileFrameScrollWrapper_1ex3u_7 ._mobileFrameScrollContainer_1ex3u_23._mobileFrameScrollContainerWizardPreview_1ex3u_31 {
      overflow: hidden; }
  ._mobileFrameScrollWrapper_1ex3u_7 ._mobileFrameScrollCover_1ex3u_33 {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-right: 17px solid #f7f8f8; }
    ._mobileFrameScrollWrapper_1ex3u_7 ._mobileFrameScrollCover_1ex3u_33._mobileFrameScrollCoverFixedMarginTop_1ex3u_39 {
      border-color: transparent; }
    ._mobileFrameScrollWrapper_1ex3u_7 ._mobileFrameScrollCover_1ex3u_33._mobileFrameScrollCoverMobileWizard_1ex3u_41 {
      display: none; }

._mobileFrame_1ex3u_7 {
  z-index: 1;
  position: absolute;
  top: 0;
  pointer-events: none;
  width: 320px;
  left: calc((100% - 320px) / 2);
  height: 100%;
  transform-origin: center 0 0;
  transition: 0.3s transform, 0.3s height; }
  ._mobileFrame_1ex3u_7 ._siteShadow_1ex3u_54 {
    position: absolute;
    background-size: contain !important;
    box-sizing: border-box;
    height: calc(100% + 50px);
    width: calc(100% + 8px);
    left: -4px;
    top: -25px;
    background: none;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.15), 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 18px 0 rgba(0, 0, 0, 0.08);
    border-color: #fff;
    border-style: solid;
    border-width: 25px 4px;
    border-radius: 18px; }
    ._mobileFrame_1ex3u_7 ._siteShadow_1ex3u_54._siteShadowSectionsExperience_1ex3u_68 {
      box-shadow: 0px -1px 8px 2px rgba(0, 0, 0, 0.08), 0px 1px 8px 2px rgba(0, 0, 0, 0.08), 2px 0px 8px 2px rgba(0, 0, 0, 0.08), -2px 0px 8px 2px rgba(0, 0, 0, 0.08); }
    ._mobileFrame_1ex3u_7 ._siteShadow_1ex3u_54:before {
      content: '';
      position: absolute;
      top: -1px;
      bottom: -1px;
      left: -1px;
      right: -1px;
      border: solid 1px #dfe5eb; }
  ._mobileFrame_1ex3u_7 ._mobileFrameTop_1ex3u_78 {
    position: absolute;
    background-size: contain !important;
    display: block;
    top: -25px;
    left: -4px;
    height: 25px;
    width: calc(100% + 8px);
    background: none;
    z-index: 1; }
    ._mobileFrame_1ex3u_7 ._mobileFrameTop_1ex3u_78:before, ._mobileFrame_1ex3u_7 ._mobileFrameTop_1ex3u_78:after {
      content: '';
      position: absolute;
      top: 50%; }
    ._mobileFrame_1ex3u_7 ._mobileFrameTop_1ex3u_78:after {
      left: 50%;
      transform: translate(14px, -50%);
      width: 8px;
      height: 8px;
      border-radius: 50px;
      border: 1px solid #dfe5eb; }
    ._mobileFrame_1ex3u_7 ._mobileFrameTop_1ex3u_78:before {
      left: 50%;
      transform: translate(-24px, -50%);
      width: 30px;
      height: 3px;
      border-radius: 2px;
      background-color: #dfe5eb; }
  ._mobileFrame_1ex3u_7 ._mobileFrameBottom_1ex3u_106 {
    position: absolute;
    background-size: contain !important;
    display: block;
    bottom: -25px;
    left: -4px;
    height: 25px;
    width: calc(100% + 8px);
    background: none;
    z-index: 1;
    pointer-events: all; }
  ._mobileFrame_1ex3u_7._previewMode_1ex3u_117 ._siteShadow_1ex3u_54 {
    max-height: calc(100% + 50px); }
  ._mobileFrame_1ex3u_7:not(._frameless_1ex3u_119) {
    animation: _mobile-frameless-out-animation_1ex3u_1 1s;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards; }
  ._mobileFrame_1ex3u_7._frameless_1ex3u_119 {
    animation: _mobile-frameless-in-animation_1ex3u_1 1s;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards; }
    ._mobileFrame_1ex3u_7._frameless_1ex3u_119 ._mobileFrameTop_1ex3u_78,
    ._mobileFrame_1ex3u_7._frameless_1ex3u_119 ._mobileFrameBottom_1ex3u_106 {
      display: none; }
    ._mobileFrame_1ex3u_7._frameless_1ex3u_119 ._siteShadow_1ex3u_54 {
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      border: none;
      border-radius: 0;
      background: none;
      box-shadow: 0 2px 7px rgba(23, 25, 28, 0.17); }
      ._mobileFrame_1ex3u_7._frameless_1ex3u_119 ._siteShadow_1ex3u_54._siteShadowSectionsExperience_1ex3u_68 {
        box-shadow: 0px -1px 8px 2px rgba(0, 0, 0, 0.08), 0px 1px 8px 2px rgba(0, 0, 0, 0.08), 2px 0px 8px 2px rgba(0, 0, 0, 0.08), -2px 0px 8px 2px rgba(0, 0, 0, 0.08); }
      ._mobileFrame_1ex3u_7._frameless_1ex3u_119 ._siteShadow_1ex3u_54:before {
        display: none; }

@keyframes _mobile-frameless-in-animation_1ex3u_1 {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }

@keyframes _mobile-frameless-out-animation_1ex3u_1 {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }
